export default __webpack_public_path__ + "static/media/notification_icon.8a3ff304.svg";